module.exports = __webpack_public_path__ + "static/cocoa_cake_slika7-cd4bad92d247b62e164f7ffb5685f3fa.jpg";